export default __webpack_public_path__ + "static/media/picMarcusLeng.69881064.png";